import * as React from "react"
import { graphql } from "gatsby"
import type { HeadFC, PageProps } from "gatsby"
import Section from "../components/section"
import Title from "../components/title"
import Paragraph from "../components/paragraph"
import '../scss/projects.scss'
import { SEO } from "../components/seo"
import Separator from "../components/separator"
import ContactsSection from "../components/contacts_section"
import { ProjectWrapper } from "../components/project_card"
import Header from "../components/header"
import Banner from "../components/banner"
import bannerBlog from "../images/banners/BlogBanner.gif"
import Footer from "../components/footer"

const IndexPage: React.FC<PageProps> = ({data} : {data: any}) => {
  return (
    <><Header
      banner={
        <Banner>
          <div className="MainBanner__Container">
          <div className="MainBanner__Image">
          <img src={bannerBlog}/>
              </div>
            
              <div className="MainBanner__Title">
                  <div className="MainBanner__TitleContent primary-color">
                      progetti
                  </div>
                  <div className="MainBanner__TitleContentMobile primary-color">
                      pr<br/>og<br/>
                      et<br/>ti
                  </div>
              </div>
          </div>
        </Banner>
      }
    />
    <main>
      <Section secondary>
        <Title
          title="Giocare"
          subtitle="per credere."
          
        />
         <Paragraph>
         Per aiutarti a immaginare meglio quello che potremmo <b>realizzare insieme</b>, abbiamo raccolto in questa sezione i progetti più rappresentativi a cui abbiamo lavorato. Ogni gioco che trovi in questa pagina ha uno stile visivo e un’atmosfera uniche, ma tutti sono accomunati da una <b>componente narrativa</b> molto sviluppata.
        </Paragraph>
      </Section>
        {
          data.allFile.nodes.map((node: any) => {
           return <ProjectWrapper node={node}/>
          })
        }
      <Separator/>
      <ContactsSection/>
      </main>
      <Footer/>
    </>
  )
}

export default IndexPage

export const query = graphql`
query {
    allFile(filter: {
      sourceInstanceName: { eq: "projects" }
    }
    sort: {
      childMdx: {
        frontmatter: {
          date: DESC
        }
      }} 
    ) {
    nodes {
      childMdx {
        frontmatter {
          title
          slug
          date
          tags
          category
          youtube_embed_url
          play_url
        }
        body
      }
    }
  }
}
`

export const Head: HeadFC = () => <SEO title="Progetti - Narrativi Digitali" description="Per aiutarti a immaginare meglio quello che potremmo realizzare insieme, abbiamo raccolto in questa sezione i progetti più rappresentativi a cui abbiamo lavorato. Ogni gioco che trovi in questa pagina ha uno stile visivo e un’atmosfera uniche, ma tutti sono accomunati da una componente narrativa molto sviluppata."/>
